import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { apiClient } from './useApi'

// Volymuppföljning (/volume3, pejlen-produkt#107)

const getTenant = () => localStorage.getItem('tenant_id') ?? ''
const getIdToken = () => localStorage.getItem('hydra_id_token') ?? ''

// Frågan är tung: ett omförsök, ingen ny hämtning vid flikbyte och fem minuters cache (F43, F44)
const FRAGEINSTALLNINGAR = { retry: 1, refetchOnWindowFocus: false, staleTime: 5 * 60 * 1000 }

export const useVolym3 = (fran: string | null, till: string | null, handlaggare: string | null) =>
  useQuery(
    ['volym3', fran, till, handlaggare],
    async () => (await apiClient.getVolume3(getTenant(), fran as string, till as string, getIdToken(), handlaggare as string)).data,
    { ...FRAGEINSTALLNINGAR, enabled: !!fran && !!till && !!handlaggare }
  )

/** Handläggaren ligger utanför de team man har behörighet till (A29). Visas som ett besked, inte som ett fel. */
export const utanforBehorighet = (error: unknown) => (error as AxiosError)?.response?.status === 403

/** Felbesked i stället för en tom tabell (F11) */
export const felbesked = (error: unknown): string => {
  const e = error as AxiosError<{ message?: string }>
  const status = e?.response?.status
  if (status === 403) return 'Du har inte behörighet att se den här handläggarens brukare.'
  if (status === 400) return `Perioden går inte att visa: ${(e.response?.data?.message || '').replace(/^Bad request: /, '')}.`
  return 'Volymuppföljning kunde inte hämtas. Försök igen om en stund.'
}
